export default "__VITE_ASSET__CJGKfiyQ__"